export const DRAWER_WIDTH = 230;
export const TAB_HEIGHT = 60;
export const SECTIONS = {
  ANALYTICS: 'analytics',
  FILES_COLLECTION_SETTINGS: 'filesCollectionSettings',
  APP_CONFIGURATION: 'appConfiguration',
  ACCESS_CONTROL: 'accessControl',
};
